import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addshipmenttype',
  templateUrl: './addshipmenttype.component.html',
  styleUrls: ['./addshipmenttype.component.css']
})
export class AddshipmenttypeComponent implements OnInit {

  
//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

//Save Validation
submitted:boolean;
successfully:boolean;


//Edit Get Values
shipmenttypeColl:any=[];
shipmenttypeid:number=0

shipmenttypeform=new FormGroup({
  shipmenttype:new FormControl('',Validators.required),         
  shipmenttypeid:new FormControl(0),      
 inactive:new FormControl(false),     
});

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress:boolean=false;
formname:String="ShipmentType";

isshipmenttypereadonly:boolean=false;

constructor(private appService: DhukanDataService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
     this.route.queryParams.subscribe(params => {
      if(params.id!==undefined){
        this.shipmenttypeid = params.id
      }  

     });

     this.fnServiceChanges();
}


fnServiceChanges(){
  this.loginService.serviceloginChange.subscribe((value) => {
        if(this.loginService.fnCheckUser()){
         
          if(this.fnCheckUserPririvilage()){
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
            
        }
        else{
          this.fnUserFailedForm();
        }
  });
}

ngOnInit() {
    try{
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
              
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}

fnOnInitForm(){
   try{
       this.isaddmode=true;
       this.shipmenttypeform.reset();
       this.fnInitializeShipmentTypeFormGroup(); 

       if(this.shipmenttypeid>0){
         this.fngetShipmentType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}



fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.shipmenttypeid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}

fnInitializeShipmentTypeFormGroup(){
   this.shipmenttypeform.setValue({
    shipmenttype:'',
    shipmenttypeid:0,      
     inactive:false,      
   })
}

//Get 
fngetShipmentType() {        
     var data = {
       'shipmenttypeid':this.shipmenttypeid,            
     }
     this.appService.getShipmentType(data)
     .subscribe(
       (res)=>{                  
         this.shipmenttypeColl=res.json().result;
         var editdata = {
           'shipmenttypeid':this.shipmenttypeColl[0].shipmenttypeid,
           'shipmenttype':this.shipmenttypeColl[0].shipmenttype, 
           'inactive':this.shipmenttypeColl[0].inactive,          
         }
         this.fnEditMode(editdata);

        if(this.shipmenttypeColl[0].shipmenttag==='OWNDELIVERY'){
          this.isshipmenttypereadonly=true
        }
         
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}

//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.shipmenttypeform.valid){
         //Check
         var data = {
               'shipmenttypeid': this.shipmenttypeid,       
               'shipmenttype':this.shipmenttypeform.get('shipmenttype').value,            
               'inactive': 0,  
               'createdby': this.loginService.fnGetModUserId(),    
               'modifiedby':this.loginService.fnGetModUserId(), 
         }
         this.appService.fnCheckShipmentType(data).subscribe(
           (res)=>{
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.shipmenttypeform.get('shipmenttypeid').value>0){
                       //Update Department
                       this.fnSetShipmentType(data);
                     }
                     else{
                       //Insert Department
                       this.fnInsertShipmentType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                       this.shipmenttypeform.controls['shipmenttype'].setErrors({'notfound': true});
                     }
               }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertShipmentType(data){    
 
   this.appService.fnInsertShipmentType(data).subscribe(
     (res)=>{
     if(res.json().result!=""){
       this.toastr.success('', "The new shipmenttype has been added successfully.Insert Successfully");

       this.fnInsertActivityLog('INSERT',0,data.shipmenttype);

       this.fnCloseShipmentType();
     }},
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetShipmentType(data){    

this.appService.fnSetShipmentType(data).subscribe(
 (res)=>{
 if(res.json().result!=""){
     this.toastr.success('', "The shipmenttype has been updated successfully.");

     this.fnInsertActivityLog('EDIT',this.shipmenttypeid,data.shipmenttype);

     this.fnCloseShipmentType();        
 }},
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseShipmentType(){
try{
  this.router.navigate(['/ShipmentType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.shipmenttypeform.setValue({
  shipmenttype:deptBO.shipmenttype,
  shipmenttypeid:deptBO.shipmenttypeid,
   inactive:deptBO.inactive,   
 });

this.isaddmode=false;
this.iseditmode=true;
this.isdeletemode=false;
this.isviewmode=false;
}



fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}


private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}




}
